"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerTextInputWrap = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const DatePickerTextInputWrap = (0, _styled.default)("div")`
    position: relative;

    // Ensure the stacking context we create in children of this
    // component doesn't override others by default.
    isolation: isolate;
`;
exports.DatePickerTextInputWrap = DatePickerTextInputWrap;
//# sourceMappingURL=DatePickerTextInputWrap.js.map